import { render, staticRenderFns } from "./LayoutSimple.vue?vue&type=template&id=6472db96"
import script from "./LayoutSimple.vue?vue&type=script&lang=ts"
export * from "./LayoutSimple.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports